import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Check from '@material-ui/icons/Check';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import LoadingIcon from '../../LoadingIcon';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import Carousel from 'react-elastic-carousel';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PostApi, GetApi } from "../../../js_assets/Network";
import { api_url } from "../../../js_assets/ConfigApp";
import FormLabel from '@material-ui/core/FormLabel';
import { useHistory } from "react-router-dom";

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['تحديـد الجنس ', 'معلومات الجسم', 'الهدف الرياضي ', ' معلومات الاتصال '];
}



export default function LandingPageTwo() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [plan, setPlan] = useState(1);
  const [emailCheck, setEmailCheck] = useState("")
  const [gender, setGender] = useState("male");
  const [weaghts, setWeaghts] = useState("");
  const [heights, setHeights] = useState("");
  const [goal, setGoal] = useState("lose");
  const [age, setAge] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [userId, setUserId] = useState(1)
  const steps = getSteps();
  const history = useHistory();
  const [proteinData, setProteinData] = useState([])
  const [phones, setphones] = useState([

    { id: 1, userName: " Asma", title: "اليوم توزنت ونازل تقريبا كيلو واشوي تقريبا بس مش راح اعتمد الشوي البرنامج ملان اكل والسعرات الحراريه زياده ٤٠٠من الي كنت عليه مش طبيعي بروووتين هاد اسمو سححححر الرشااااقه ❤️❤️❤️❤️" },
    { id: 2, userName: " ساره", title: "النظام مرن و الوجبات مررة متنوعة وسهلة وأهم شيء إنها تشبع وما أحس بجوع لفترة طويلة بالإضافة إلى إن مافيه حرمان من أي شيء😍😍" },
    { id: 3, userName: " امال", title: "الجدول ممتااز فيه افكار ابداعيه وسهل التطبيق 😍💚 وجدا ممتع انهرت عليه😭💚💚" },
    { id: 4, userName: " Shatha", title: "جدول رائع غني ومتنوع من ناحيه التمارين ومن ناحيه الوجبات والسناكات ما فيه حرمان، سهل ومحفز وباعث للحماس🤸🏿‍♂️🤸🏿‍♂️" },
    { id: 5, userName: " عبدالعزيز", title: "الصراحة الجدول ممتاز ومتنوع مرة، والمدرب يحمسك ومتعاون ويجاوب على كل شي، باذن الله مو اخر مرة🔥" },
    { id: 6, userName: " علياء", title: "النظام يجننن ويردون بسرعه مع اني طفشتهم كل شوي اسأل الا انهم يعملون بذمه وضمير" },
  ])


  useEffect(() => {

    GetApi("/api/trainer/Get_Protein_Data_For_Landing_Page", null).then(rep => {
      setProteinData(rep)

    })
  }, []);

  function urlTo(type) {
    if (type == "ios") {
      window.location = "https://apps.apple.com/us/app/protein/id1473589285";
    } else if ("android") {
      window.location =
        "https://play.google.com/store/apps/details?id=com.protein_app_1c410.firebaseapp.base";


    } else { return; }

  }
  const sendData = () => {
    let RegisterUserModel = {
      userName: name.trim(),
      user_Email: email.trim(),
      user_Phone: phone,

    };

    let Health_Profile_Model = {
      user_Age: age,
      userId: 0,
      user_Length: heights,
      user_Weight: weaghts,
      activity_Level: "0",
      user_Gender: gender,
      health_Goal: goal,
      number_Of_Meals: "0",
      number_Of_Hours_Of_Sleep: "0",
      health_Statas: "",
      Measure_shoulders: "0",
      measure_Ulna: "0",
      measure_buttocks: "0",
      measure_legs: "0",
      measure_abdomen: "0",
      measure_Waist: "0",
      measure_Thigh: "0",
      measure_Chest: "0",
    }
    setIsLoading(true)

    PostApi("/api/Validation/RegisterUserLandingPage", RegisterUserModel).then((rep) => {

      if (rep.status === true && email.trim() !== "") {

        setUserId(rep.userId)
        Health_Profile_Model.userId = rep.userId

        PostApi(`/api/User/Save_Health_Profile_LandingPage`, Health_Profile_Model).then(() => {

          setActiveStep((prevActiveStep) => prevActiveStep + 1);

        })


      } else if (rep.status === false && email.trim() !== "") {

        setEmailCheck(" البريد الالكتروني مستخدم بالفعل*")
      } else if (email.trim() === "") {

        setEmailCheck("نرجوا ادخال البريد الالكتروني*")
      }

      setIsLoading(false)
    })

  }
  function paymentPage() {
    var followUp_Schedule = proteinData.find(e => e.schedule_Package_Type_Id == plan);
    history.push(`/WebViewPayment?amount_required=${process.env.NODE_ENV === "development" ? 1 : followUp_Schedule.followUp_Schedule_Price}&followUp_Schedule_Id=${followUp_Schedule.followUp_Schedule_Id}&trainer_Id=${followUp_Schedule.trainer_Id}&userId=${userId}`);
  }
  function getStepContent(step) {

    // const handleChange = (event) => {
    //   setGoal(event.target.value);
    // };

    switch (step) {
      case 0:
        return (
          <div style={{ height: 285, }} >
            <div style={{ paddingRight: 20, marginTop: 35 }}>

              <span style={{ fontSize: 18, color: "grey" }}>    الرجاء تحديد الجنس  </span>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignContent: "center", justifyContent: "center", marginTop: "20%" }}>
              <div onClick={() => setGender("male")} style={{ height: 135, width: 135, borderRadius: 70, backgroundColor: "#b1d236", opacity: gender === "fmale" ? 0.5 : 1, display: "flex", alignItems: "center", justifyContent: "center", marginleft: 10, color: "white", fontSize: 17 }}>
                ذكر
              </div>
              <div onClick={() => setGender("fmale")} style={{ height: 135, width: 135, borderRadius: 70, backgroundColor: "#b1d236", opacity: gender === "male" ? 0.5 : 1, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10, color: "white", fontSize: 17 }}>
                انثى
              </div>
            </div>

          </div>)
      case 1:
        return (


          <div style={{ display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center", height: 297, }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginBottom: 10 }}>

              <span style={{ fontSize: 16, marginBottom: 7 }}>  العمر</span>
              <div style={{ width: "30%" }}>
                <TextField style={{ width: "100%" }} id="outlined-basic" variant="outlined" type="number" onChange={(event) => setAge(event.target.value)} value={age} />
              </div>

            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginBottom: 10 }}>
              <span style={{ fontSize: 16, marginBottom: 7 }} > الوزن </span>
              <div style={{ width: "30%" }}>
                <TextField style={{ width: "100%" }} id="outlined-basic" type="number" variant="outlined" onChange={(event) => setWeaghts(event.target.value)} value={weaghts} placeholder="الوزن بالكيلو" />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginBottom: 10 }}>
              <span style={{ fontSize: 16, marginBottom: 7 }}> الطول </span>
              <div style={{ width: "30%" }}>
                <TextField style={{ width: "100%" }} id="outlined-basic" variant="outlined" type="number" onChange={(event) => setHeights(event.target.value)} value={heights} placeholder="الطول (سم)    " />
              </div>
            </div>
          </div>
        )
      case 2:
        return (
          // <div style={{ display: "flex", flexDirection: "column", height: 297, marginRight: 20, marginTop: "10%" }} >
          //   <FormControl component="fieldset">
          //     <span style={{ fontSize: 16 }}>  حدد هدفك </span>
          //     <RadioGroup aria-label="goal" name="goal" value={goal} onChange={handleChange}>
          //       <div style={{ display: "flex", flexDirection: "row", }}>

          //         <FormControlLabel value="less" control={<Radio />} label="نزول وزن" />

          //       </div>
          //       <div style={{ display: "flex", flexDirection: "row", marginTop: -20 }}>
          //         <FormControlLabel value="more" control={<Radio />} label="زيادة وزن" />
          //       </div>


          //     </RadioGroup>
          //   </FormControl>



          // </div>

          <div style={{ height: 285, }} >
            <div style={{ paddingRight: 20, marginTop: 35 }}>

              <span style={{ fontSize: 18, color: "grey" }}>    الرجاء تحديد الهدف  </span>
            </div>

            <div style={{ display: "flex", flexDirection: "row", alignContent: "center", justifyContent: "center", marginTop: "20%" }}>
              <div onClick={() => setGoal("lose")} style={{ height: 135, width: 135, borderRadius: 10, backgroundColor: "#b1d236", opacity: goal === "gain" ? 0.5 : 1, display: "flex", alignItems: "center", justifyContent: "center", marginleft: 10, color: "white", fontSize: 17 }}>
                نزول الوزن
              </div>
              <div onClick={() => setGoal("gain")} style={{ height: 135, width: 135, borderRadius: 10, backgroundColor: "#b1d236", opacity: goal === "lose" ? 0.5 : 1, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10, color: "white", fontSize: 17 }}>
                زيادة الوزن
              </div>
            </div>

          </div>

        )
      case 3:
        return (

          <div style={{ display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center", height: 297, marginRight: 20 }}>
            <span style={{ fontSize: 16, marginBottom: 7 }}> الاسم</span>

            <div style={{ width: "95%" }}>
              <TextField style={{ width: "100%" }} id="outlined-basic" variant="outlined" onChange={(event) => setName(event.target.value)} value={name} />
            </div>
            <span style={{ fontSize: 16, marginBottom: 7, marginTop: 10 }}> البريد الالكتروني</span>
            <div style={{ width: "95%" }}>
              <TextField style={{ width: "100%" }} id="outlined-basic" variant="outlined" onChange={(event) => setEmail(event.target.value)} value={email} />
              {emailCheck && <span style={{ color: "red" }}> {emailCheck}</span>}
            </div>
            <span style={{ fontSize: 16, marginBottom: 7, marginTop: 10 }}> رقم الجوال</span>
            <div style={{ width: "95%" }}>
              <TextField style={{ width: "100%" }} id="outlined-basic" variant="outlined" type="number" onChange={(event) => setPhone(event.target.value)} value={phone} />
            </div>
          </div>
        )
      default:
        return (
          <div style={{ height: 285, }} >


          </div>)
    }
  }


  const handleNext = () => {
    if (activeStep !== steps.length - 1) {

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    else if (activeStep === steps.length - 1) {
      sendData()

    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };



  return (
    <div className={classes.root}>
      {isLoading && <LoadingIcon />}
      <img src={require("../LandingPage/imge/header.png")} width={"100%"} />
      <Stepper style={{}} activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label} style={{ marginRight: -9 }} >
            <StepLabel  >{""}</StepLabel>
            <div style={{ width: 83, }}>

              <span style={{ fontSize: 11, marginRight: -10 }}>{label}</span>
            </div>
          </Step>
        ))}
      </Stepper>


      <div style={{ marginTop: -20 }}>
        {activeStep === steps.length ?
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>

            <div style={{ height: 400, width: 330, backgroundColor: "#e8e9e2", color: "black", paddingRight: 10, paddingTop: 10, borderRadius: 5, marginTop: 10, marginBottom: 10 }}>
              <span style={{ fontWeight: "bold", fontSize: 18 }}>أنت على بعد خطوة واحدة من حياة مختلفة !</span>
              <br></br>
              <div style={{ marginTop: 10, color: "inherit" }}>
                <span style={{ fontWeight: "bold", fontSize: 17, marginTop: 50 }}>اختر الباقة المناسبة لك</span>
                <div style={{ color: "inherit", paddingRight: 5 }}>
                  {
                    proteinData.length != 0 &&

                    proteinData.map(rep => {

                      return (
                        <div onClick={() => setPlan(rep.schedule_Package_Type_Id)} style={plan === rep.schedule_Package_Type_Id ? { borderStyle: "solid", height: 35, width: 280, display: "flex", alignItems: "center", marginRight: -10, paddingRight: 10, borderWidth: 0.9, backgroundColor: "rgb(129 156 47 / 57%)", borderRadius: 5, borderColor: "#fffafa00", color: "black" } : { opacity: 0.6, color: "black" }}>
                          <span style={{ fontWeight: 200, fontSize: 15 }}> برنامج {rep.schedule_Package_Type_Name}				{rep.followUp_Schedule_Price} ريال < span style={{ color: "rgb(216 85 85)", textDecoration: "line-through" }}> ( 425 ريال) </span></span>
                        </div>
                      )
                    })

                  }

                </div>
                <div style={{ marginTop: 10, color: "inherit", height: 111 }}>
                  <span style={{ fontWeight: "bold", fontSize: 17 }}>ما تتضمنه الباقة</span>
                  <br></br>
                  <div style={{ color: "inherit", paddingRight: 5 }}>
                    <span style={{ fontWeight: 200, fontSize: 15 }}>✓ نظام محسوب السعرات الحرارية</span>
                    <br></br>
                    <span style={{ fontWeight: 200, fontSize: 15 }}>✓ اكثر من 380 صنف متنوع</span>
                    <br></br>
                    <span style={{ fontWeight: 200, fontSize: 15 }}> ✓ سهولة تبديل الأصناف خلال الشهر</span>
                    <br></br>
                    <span style={{ fontWeight: 200, fontSize: 15 }}> ✓ إرشادات ونصائح لنتائج أفضل </span>
                    <br></br>
                    {plan === 3 ?
                      <span style={{ fontWeight: 200, fontSize: 15 }}> ✓ نظام رياضي يناسب البيت/النادي </span> :
                      <span> </span>
                    }
                  </div>
                </div>

              </div>

              <div style={{ width: "100%", height: 50, display: "flex", alignItems: "center", justifyContent: "center", marginTop: 37 }}>
                <button onClick={() => paymentPage()} style={{ width: 150, borderColor: "white", color: "white", borderStyle: "solid", height: 40, fontFamily: "inherit", borderRadius: 5, backgroundColor: "rgba(129, 156, 47, 0.57)", borderWidth: 0 }}> اشترك الان</button>

              </div>
            </div>
            <Carousel
              enableAutoPlay={true}
              isRTL={true}
              itemsToShow={1}
              pagination={false}
              showArrows={false}>
              {phones.map(item =>
                <div key={item.id}>
                  <div style={{ height: 150, width: 330, boxShadow: "rgb(196 195 196) 8px 7px", padding: 10, marginTop: 10, fontSize: 16, borderStyle: "solid", borderColor: "#b1d236" }} >
                    <div style={{ color: "#b1d236", fontSize: 16 }}>
                      {item.userName}
                    </div>
                    <div style={{ fontSize: 14, fontWeight: "normal" }}>

                      {item.title}
                    </div>

                  </div>

                </div>)}
            </Carousel>

          </div>
          :
          <div>
            <div className={classes.instructions}>{getStepContent(activeStep)}</div>
            <div style={{ marginTop: 20, width: "100%", alignItems: "center", justifyContent: "center", display: "flex" }}>
              <Button disabled={activeStep === 0 || isLoading} onClick={handleBack} className={classes.button}>
                السابق
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                disabled={isLoading}
                className={classes.button}
              >
                {activeStep === steps.length - 1 ? 'انهاء' : 'التالي'}
              </Button>
            </div>
          </div>}



      </div>
      <div style={{ position: "relative", marginTop: -10 }}>
        <img src={require("../LandingPage/imge/footer.png")} width={"100%"} height={130} />

        <div style={{
          display: "flex",
          flexDirection: 'row-reverse',

          alignItems: "center",
          justifyContent: "space-between",
          position: "absolute"
          , top: 40,
          width: "100%",
        }}>
          <div style={{ color: "#b1d136", fontSize: 14, marginRight: 5, display: "flex", flexDirection: "column", paddingLeft: 10, justifyContent: "flex-start", width: "40%", }}>
            <span style={{ marginRight: 30 }} > تواصل معنا</span>
            <div style={{
              display: "flex",
              flexDirection: "row",




            }}>

              <img onClick={() => window.location = "https://api.whatsapp.com/send?phone=966533835233"} src={require("../LandingPage/imge/whats.png")} width={40} height={35} />
              <img onClick={() => window.location = "https://twitter.com/protein_40/status/1342462246102949890?s=21"} src={require("../LandingPage/imge/twitter.png")} width={40} height={35} />
              <img onClick={() => window.location = "https://instagram.com/protein_40?igshid=1kcodp7qxgap2"} src={require("../LandingPage/imge/insta.png")} width={40} height={35} />
            </div>
          </div>
          <div style={{
            color: "#b1d136", fontSize: 14, marginRight: 5, paddingLeft: 10,
            width: "60%"
          }}>
            <span style={{ marginRight: 10 }} >  اضغط لتحميل التطبيق</span>


            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginRight: 5
              ,
              width: "100%"
            }} >
              <img onClick={() => urlTo("android")} src={require("../LandingPage/imge/google.png")} width={"50%"} />
              <img onClick={() => urlTo("ios")} src={require("../LandingPage/imge/apple.png")} width={"50%"} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
